// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e48bdad0","71":"770371ec","238":"06210026","239":"ad8426b2","453":"b74d57f2","455":"7560bc19","582":"74a1d01f","594":"91ed7348","857":"6261962d","977":"b30e6ca9"}[chunkId] + ".chunk.js";
};